<template>
	<div class="goods-main">
		<!-- <div style="width: 600px; margin: 0 auto;">
			<img src="../../../static/building.png" style="height: 100%; width: 100%;" alt="">
		</div> -->
		<div class="goods-block">
			<div class="goods-list-main">
				<div class="goods-box" v-for="(item, index) in goodsList" :key="index">
					<img :src="$imgUrl + item.listImgPc" alt="">
					<div class="goods-bottom">
						<div class="goods-bottom-left">
							<div class="goods-bottom-top">
								<div class="goods-bottom-top-left">
									{{item.title}}
								</div>
							</div>
							<div class="goods-bottom-bottom">
								<div>
									<i class="iconfont icondianzan" v-if="item.isLike == 'YES'">

									</i>
									<i class="iconfont icondianzan" v-else style="color: #B0B0B0;">

									</i>
									<span style="margin: 0 30px 0 10px;">
										{{item.likeNum}}
									</span>
								</div>
								<div>
									<i class="iconfont iconxihuan" v-if="item.isCollection == 'YES'">

									</i>
									<i class="iconfont iconxihuan" v-else style="color: #B0B0B0;">

									</i>
									<span style="margin: 0 30px 0 10px;">
										{{item.collectionNum}}
									</span>
								</div>
							</div>
						</div>
						<div class="goods-bottom-right" @click="toDetails(item.id)">
							LEARN NOW
						</div>
					</div>
				</div>
			</div>
			<page :pageObj="params" @getDataList="getGoodsList" ref="page"></page>
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page,
		},
		data() {
			return {
				goodsList: [],
				params: {
					current: 1,
					size: 6,
					channelId: this.$store.state.channelId,
					url: '/api/channel/findContentListByChannelId'
				}
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_4.png'
		},
		methods: {
			changeType(type) {
				if(type == this.params.type) {
					return
				}
				this.params.type = type
				this.params.current = 1
				this.$refs.page.getData()
			},
			getGoodsList(goods) {
				document.body.scrollTop = document.documentElement.scrollTop = 0
				this.goodsList = goods
			},
			searchData() {
				this.params.current = 1
				this.$refs.page.getData()
			},
			toDetails(lesson_id) {
				this.$router.push({
					path: '/dekt_details',
					query: {
						lesson_id: lesson_id
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.goods-main {
		width: 74%;
		margin: 30px 13% 40px;
		.category {
			display: flex;
			justify-content: space-between;
			.category-list {
				display: flex;
				.category-box {
					margin-right: 30px;
					height: 30px;
					line-height: 30px;
					padding: 0 15px;
					cursor: pointer;
					font-size: 12px;
				}
			}
			.search-box {
				height: 37px;
				line-height: 37px;
				display: flex;
				justify-content: center;
				position: relative;
				.input-box {
					position: absolute;
					right: 13%;
					top: 5px;
					width: 200px;
					padding: 0 35px 0 10px;
					height: 25px;
					border: 1px solid #264EA7;
					background-color: #FFFFFF;
					color: #1059BF;
				}
				.search-icon {
					position: absolute;
					right: 13%;
					top: 5px;
					width: 60px;
					height: 25px;
					background-color: #264EA7;
					color: #FFFFFF;
					line-height: 25px;
					text-align: center;
					cursor: pointer;
					i {
						font-size: 16px;
					}
				}
			}
		}
		.goods-block {
			padding: 20px 0 40px;
			.goods-list-main {
				width: 100%;
				display: flex;
				flex-wrap: wrap;
				.goods-box {
					width: 32%;
					margin: 10px 0.5%;
					height: auto;
					display: flex;
					flex-direction: column;
					img {
						width: 100%;
						height: 100%;
					}
					.goods-bottom {
						border: 3px solid #EDD68E;
						padding: 5px 15px;
						font-size: 13px;
						color: #686868;
						display: flex;
						position: relative;
						.goods-bottom-left {
							width: 70%;
							.goods-bottom-top {
								display: flex;
								height: 20px;
								line-height: 20px;
								justify-content: space-between;
								overflow: hidden;
								text-overflow: ellipsis;
								.goods-bottom-top-left {
									text-align: left;
								}
								.goods-bottom-top-right {
									width: 90px;
									background-color: #EDD68E;
									color: #FFFFFF;
									text-align: center;
								}
							}
							.goods-bottom-bottom {
								display: flex;
								height: 30px;
								line-height: 30px;
								margin-top: 5px;
								.iconfont {
									font-size: 20px;
									color: #922627;
								}
							}
						}
						.goods-bottom-right {
							position: absolute;
							bottom: 10px;
							height: 27px;
							line-height: 27px;
							width: 25%;
							background-color: #CDA63A;
							color: #FFFFFF;
							right: 10px;
							cursor: pointer;
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/education/onlinecourses.vue